export enum ImageColorType {
  Default = 'Default',
  Inverted = 'Inverted',
}
